import React from 'react';
import './ModulesCustomization.css';

const ModulesCustomization = ({ formData, updateFormData }) => {
  // Afficher les modules seulement si un template est sélectionné
  if (!formData.template) {
    return (
      <div className="modules-container">
        <p>Sélectionnez d'abord un modèle pour accéder aux options de personnalisation.</p>
      </div>
    );
  }

  // Modules spécifiques au template Moderne
  const renderModerneModules = () => (
    <div className="modules-container">
      <h4>{getTemplateName(formData.template)}</h4>
      
      {/* Afficher la barre verticale */}
      <div className="form-group">
        <label className="form-label">Afficher la barre verticale</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.afficherBarre !== 'non'}
            onChange={(e) => updateFormData('afficherBarre', e.target.checked ? 'oui' : 'non')}
          />
          <span>Activer la barre verticale</span>
        </label>
      </div>

      {/* Épaisseur de la barre verticale */}
      {formData.afficherBarre !== 'non' && (
        <div className="form-group">
          <label className="form-label" htmlFor="epaisseurBarre">
            Épaisseur de la barre verticale: {formData.epaisseurBarre || 4}px
          </label>
          <input
            type="range"
            id="epaisseurBarre"
            className="form-range"
            min="1"
            max="8"
            value={formData.epaisseurBarre || 4}
            onChange={(e) => updateFormData('epaisseurBarre', parseInt(e.target.value))}
          />
        </div>
      )}

      {/* Position de la photo profil */}
      <div className="form-group">
        <label className="form-label" htmlFor="photoPosition">Position de la photo profil</label>
        <select
          id="photoPosition"
          className="form-input"
          value={formData.photoPosition || 'centrer'}
          onChange={(e) => updateFormData('photoPosition', e.target.value)}
        >
          <option value="haut">Haut</option>
          <option value="centrer">Centrer</option>
          <option value="bas">Bas</option>
        </select>
      </div>

      {/* Contour de la photo */}
      <div className="form-group">
        <label className="form-label">Contour de la photo</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.photoContour || false}
            onChange={(e) => updateFormData('photoContour', e.target.checked)}
          />
          <span>Activer le contour de couleur de la photo profil</span>
        </label>
      </div>

      {/* Format de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="photoFormat">Format de la photo profil</label>
        <select
          id="photoFormat"
          className="form-input"
          value={formData.photoFormat || 'carre'}
          onChange={(e) => updateFormData('photoFormat', e.target.value)}
        >
          <option value="carre">Carré</option>
          <option value="carre-arrondi">Carré arrondi</option>
          <option value="rond">Rond</option>
        </select>
      </div>

      {/* Icônes des informations de contact */}
      <div className="form-group">
        <label className="form-label">Icônes de contact</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.contactIconsEnabled || false}
            onChange={(e) => updateFormData('contactIconsEnabled', e.target.checked)}
          />
          <span>Activer les icônes des informations de contact</span>
        </label>
      </div>
    </div>
  );

  // Modules spécifiques au template Corporate
  // Modules spécifiques au template Corporate
  const renderCorporateModules = () => (
    <div className="modules-container">
      <h4>{getTemplateName(formData.template)}</h4>
      
      {/* Style de bordure */}
      <div className="form-group">
        <label className="form-label" htmlFor="corporateBorderStyle">Style de bordure</label>
        <select
          id="corporateBorderStyle"
          className="form-input"
          value={formData.corporate?.borderStyle || 'normal'}
          onChange={(e) => updateFormData('corporate', { ...formData.corporate, borderStyle: e.target.value })}
        >
          <option value="normal">Bordure classique</option>
          <option value="sans-bordure">Sans bordure</option>
          <option value="arrondi">Arrondi moderne</option>
        </select>
      </div>

      {/* Position de la photo profil */}
      <div className="form-group">
        <label className="form-label" htmlFor="corporatePhotoPosition">Position de la photo profil</label>
        <select
          id="corporatePhotoPosition"
          className="form-input"
          value={formData.corporate?.photoPosition || 'droite'}
          onChange={(e) => updateFormData('corporate', { ...formData.corporate, photoPosition: e.target.value })}
        >
          <option value="droite">À droite</option>
          <option value="gauche">À gauche</option>
        </select>
      </div>

      {/* Contour de la photo */}
      <div className="form-group">
        <label className="form-label">Contour de la photo</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.corporate?.photoContour || false}
            onChange={(e) => updateFormData('corporate', { ...formData.corporate, photoContour: e.target.checked })}
          />
          <span>Activer le contour de couleur de la photo profil</span>
        </label>
      </div>

      {/* Affichage des labels */}
      <div className="form-group">
        <label className="form-label" htmlFor="corporateLabelsDisplay">Affichage des labels</label>
        <select
          id="corporateLabelsDisplay"
          className="form-input"
          value={formData.corporate?.labelsDisplay || 'labels'}
          onChange={(e) => updateFormData('corporate', { ...formData.corporate, labelsDisplay: e.target.value })}
        >
          <option value="labels">Labels (Tél:, Email:, etc.)</option>
          <option value="pictogrammes">Pictogrammes uniquement</option>
          <option value="non-visibles">Non visibles</option>
        </select>
      </div>
  </div>
);

// Modules spécifiques au template Carte
const renderCarteModules = () => (
    <div className="modules-container">
      <h4>{getTemplateName(formData.template)}</h4>
      
      {/* Type de photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="cartePhotoFormat">Type de photo</label>
        <select
          id="cartePhotoFormat"
          className="form-input"
          value={formData.carte?.photoFormat || 'carre-arrondi'}
          onChange={(e) => updateFormData('carte', { ...formData.carte, photoFormat: e.target.value })}
        >
          <option value="rond">Rond</option>
          <option value="carre-arrondi">Carré arrondi</option>
          <option value="carre">Carré</option>
        </select>
      </div>

      {/* Position de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="cartePhotoPosition">Position de la photo</label>
        <select
          id="cartePhotoPosition"
          className="form-input"
          value={formData.carte?.photoPosition || 'droite'}
          onChange={(e) => updateFormData('carte', { ...formData.carte, photoPosition: e.target.value })}
        >
          <option value="droite">À droite</option>
          <option value="gauche">À gauche</option>
        </select>
      </div>

      {/* Contour de la photo */}
      <div className="form-group">
        <label className="form-label">Contour de la photo</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.carte?.photoContour || false}
            onChange={(e) => updateFormData('carte', { ...formData.carte, photoContour: e.target.checked })}
          />
          <span>Activer le contour de couleur sur la photo</span>
        </label>
      </div>

      {/* Couleur de fond de la carte */}
      <div className="form-group">
        <label className="form-label" htmlFor="carteFondCouleur">Couleur de fond de la carte</label>
        <input
          type="color"
          id="carteFondCouleur"
          className="color-input"
          value={formData.carte?.fondCouleur || '#f8f9fa'}
          onChange={(e) => updateFormData('carte', { ...formData.carte, fondCouleur: e.target.value })}
        />
      </div>

      {/* Border radius du fond de carte */}
      <div className="form-group">
        <label className="form-label" htmlFor="carteBorderRadius">
          Coins arrondis de la carte: {formData.carte?.borderRadius || 0}px
        </label>
        <input
          type="range"
          id="carteBorderRadius"
          className="form-range"
          min="0"
          max="20"
          value={formData.carte?.borderRadius || 0}
          onChange={(e) => updateFormData('carte', { ...formData.carte, borderRadius: parseInt(e.target.value) })}
        />
      </div>
    </div>
  );

  // Modules spécifiques au template Moderne 2
  const renderModerne2Modules = () => (
    <div className="modules-container">
      <h4>{getTemplateName(formData.template)}</h4>
      
      {/* Afficher la barre verticale */}
      <div className="form-group">
        <label className="form-label">Afficher la barre verticale</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={(formData.moderne2?.afficherBarre || 'oui') === 'oui'}
            onChange={(e) => updateFormData('moderne2', { ...formData.moderne2, afficherBarre: e.target.checked ? 'oui' : 'non' })}
          />
          <span>Activer la barre verticale</span>
        </label>
      </div>

      {/* Épaisseur de la barre verticale */}
      {(formData.moderne2?.afficherBarre || 'oui') === 'oui' && (
        <div className="form-group">
          <label className="form-label" htmlFor="moderne2EpaisseurBarre">
            Épaisseur de la barre verticale: {formData.moderne2?.epaisseurBarre || 4}px
          </label>
          <input
            type="range"
            id="moderne2EpaisseurBarre"
            className="form-range"
            min="1"
            max="8"
            value={formData.moderne2?.epaisseurBarre || 4}
            onChange={(e) => updateFormData('moderne2', { ...formData.moderne2, epaisseurBarre: parseInt(e.target.value) })}
          />
        </div>
      )}

      {/* Position de la photo profil */}
      <div className="form-group">
        <label className="form-label" htmlFor="moderne2PhotoPosition">Position de la photo profil</label>
        <select
          id="moderne2PhotoPosition"
          className="form-input"
          value={formData.moderne2?.photoPosition || 'centrer'}
          onChange={(e) => updateFormData('moderne2', { ...formData.moderne2, photoPosition: e.target.value })}
        >
          <option value="haut">Haut</option>
          <option value="centrer">Centrer</option>
          <option value="bas">Bas</option>
        </select>
      </div>

      {/* Contour de la photo */}
      <div className="form-group">
        <label className="form-label">Contour de la photo</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.moderne2?.photoContour || false}
            onChange={(e) => updateFormData('moderne2', { ...formData.moderne2, photoContour: e.target.checked })}
          />
          <span>Activer le contour de couleur de la photo profil</span>
        </label>
      </div>

      {/* Format de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="moderne2PhotoFormat">Format de la photo profil</label>
        <select
          id="moderne2PhotoFormat"
          className="form-input"
          value={formData.moderne2?.photoFormat || 'rond'}
          onChange={(e) => updateFormData('moderne2', { ...formData.moderne2, photoFormat: e.target.value })}
        >
          <option value="carre">Carré</option>
          <option value="carre-arrondi">Carré arrondi</option>
          <option value="rond">Rond</option>
        </select>
      </div>

      {/* Icônes des informations de contact */}
      <div className="form-group">
        <label className="form-label">Icônes de contact</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.moderne2?.contactIconsEnabled || false}
            onChange={(e) => updateFormData('moderne2', { ...formData.moderne2, contactIconsEnabled: e.target.checked })}
          />
          <span>Activer les icônes des informations de contact</span>
        </label>
      </div>
    </div>
  );

  // Modules spécifiques au template Moderne 3
  const renderModerne3Modules = () => (
    <div className="modules-container">
      <h4>{getTemplateName(formData.template)}</h4>
      
      {/* Afficher la barre verticale */}
      <div className="form-group">
        <label className="form-label">Afficher la barre verticale</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={(formData.moderne3?.afficherBarre || 'oui') === 'oui'}
            onChange={(e) => updateFormData('moderne3', { ...formData.moderne3, afficherBarre: e.target.checked ? 'oui' : 'non' })}
          />
          <span>Activer la barre verticale</span>
        </label>
      </div>

      {/* Épaisseur de la barre verticale */}
      {(formData.moderne3?.afficherBarre || 'oui') === 'oui' && (
        <div className="form-group">
          <label className="form-label" htmlFor="moderne3EpaisseurBarre">
            Épaisseur de la barre verticale: {formData.moderne3?.epaisseurBarre || 4}px
          </label>
          <input
            type="range"
            id="moderne3EpaisseurBarre"
            className="form-range"
            min="1"
            max="8"
            value={formData.moderne3?.epaisseurBarre || 4}
            onChange={(e) => updateFormData('moderne3', { ...formData.moderne3, epaisseurBarre: parseInt(e.target.value) })}
          />
        </div>
      )}

      {/* Position de la photo profil */}
      <div className="form-group">
        <label className="form-label" htmlFor="moderne3PhotoPosition">Position de la photo profil</label>
        <select
          id="moderne3PhotoPosition"
          className="form-input"
          value={formData.moderne3?.photoPosition || 'centrer'}
          onChange={(e) => updateFormData('moderne3', { ...formData.moderne3, photoPosition: e.target.value })}
        >
          <option value="haut">Haut</option>
          <option value="centrer">Centrer</option>
          <option value="bas">Bas</option>
        </select>
      </div>

      {/* Contour de la photo */}
      <div className="form-group">
        <label className="form-label">Contour de la photo</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.moderne3?.photoContour || false}
            onChange={(e) => updateFormData('moderne3', { ...formData.moderne3, photoContour: e.target.checked })}
          />
          <span>Activer le contour de couleur de la photo profil</span>
        </label>
      </div>

      {/* Format de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="moderne3PhotoFormat">Format de la photo profil</label>
        <select
          id="moderne3PhotoFormat"
          className="form-input"
          value={formData.moderne3?.photoFormat || 'rond'}
          onChange={(e) => updateFormData('moderne3', { ...formData.moderne3, photoFormat: e.target.value })}
        >
          <option value="carre">Carré</option>
          <option value="carre-arrondi">Carré arrondi</option>
          <option value="rond">Rond</option>
        </select>
      </div>

      {/* Icônes des informations de contact */}
      <div className="form-group">
        <label className="form-label">Icônes de contact</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.moderne3?.contactIconsEnabled || false}
            onChange={(e) => updateFormData('moderne3', { ...formData.moderne3, contactIconsEnabled: e.target.checked })}
          />
          <span>Activer les icônes des informations de contact</span>
        </label>
      </div>

      {/* Position des icônes sociales */}
      <div className="form-group">
        <label className="form-label" htmlFor="moderne3SocialPosition">Position des icônes sociales</label>
        <select
          id="moderne3SocialPosition"
          className="form-input"
          value={formData.moderne3?.socialPosition || 'verticale-droite'}
          onChange={(e) => updateFormData('moderne3', { ...formData.moderne3, socialPosition: e.target.value })}
        >
          <option value="verticale-droite">Verticale à droite</option>
          <option value="horizontale-bas">Horizontale en bas</option>
        </select>
      </div>
    </div>
  );

  // Obtenir le nom du template depuis la liste des templates
  const getTemplateName = (templateId) => {
    const templates = [
      { id: 'moderne', name: 'Moderne' },
      { id: 'moderne2', name: 'Moderne 2' },
      { id: 'moderne3', name: 'Moderne 3' },
      { id: 'carte', name: 'Carte' },
      { id: 'minimal', name: 'Minimal' },
      { id: 'corporate', name: 'Corporate' },
      { id: 'creatif', name: 'Créatif' },
      { id: 'tech', name: 'Tech' }
    ];
    const template = templates.find(t => t.id === templateId);
    return template ? template.name : templateId;
  };

  // Modules spécifiques au template Créatif
  const renderCreatifModules = () => (
    <div className="modules-container">
      <h4>{getTemplateName(formData.template)}</h4>
      
      {/* Forme de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="creatifPhotoFormat">Forme de la photo</label>
        <select
          id="creatifPhotoFormat"
          className="form-input"
          value={formData.creatif?.photoFormat || 'rond'}
          onChange={(e) => updateFormData('creatif', { ...formData.creatif, photoFormat: e.target.value })}
        >
          <option value="rond">Rond</option>
          <option value="carre-arrondi">Carré arrondi</option>
          <option value="carre">Carré</option>
        </select>
      </div>

      {/* Position de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="creatifPhotoPosition">Position de la photo</label>
        <select
          id="creatifPhotoPosition"
          className="form-input"
          value={formData.creatif?.photoPosition || 'droite'}
          onChange={(e) => updateFormData('creatif', { ...formData.creatif, photoPosition: e.target.value })}
        >
          <option value="droite">À droite</option>
          <option value="gauche">À gauche</option>
        </select>
      </div>

      {/* Contour de la photo */}
      <div className="form-group">
        <label className="form-label">Contour de la photo</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.creatif?.photoContour !== false}
            onChange={(e) => updateFormData('creatif', { ...formData.creatif, photoContour: e.target.checked })}
          />
          <span>Activer le contour de couleur de la photo profil</span>
        </label>
      </div>

      {/* Émojis avant les textes */}
      <div className="form-group">
        <label className="form-label">Émojis avant les textes</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.creatif?.emojisEnabled !== false}
            onChange={(e) => updateFormData('creatif', { ...formData.creatif, emojisEnabled: e.target.checked })}
          />
          <span>Activer les émojis avant les informations</span>
        </label>
      </div>

      {/* Emplacement des icônes réseaux sociaux */}
      <div className="form-group">
        <label className="form-label" htmlFor="creatifSocialPosition">Emplacement des icônes réseaux sociaux</label>
        <select
          id="creatifSocialPosition"
          className="form-input"
          value={formData.creatif?.socialPosition || 'horizontal'}
          onChange={(e) => updateFormData('creatif', { ...formData.creatif, socialPosition: e.target.value })}
        >
          <option value="horizontal">Horizontal (sous les textes)</option>
          <option value="vertical">Horizontal (sous la photo)</option>
        </select>
      </div>

      {/* Couleur de fond du background */}
      <div className="form-group">
        <label className="form-label" htmlFor="creatifBackgroundColor">Couleur de fond du background</label>
        <input
          type="color"
          id="creatifBackgroundColor"
          className="color-input"
          value={formData.creatif?.backgroundColor || '#ffffff'}
          onChange={(e) => updateFormData('creatif', { ...formData.creatif, backgroundColor: e.target.value })}
        />
      </div>
    </div>
  );

  // Modules spécifiques au template Minimal
  const renderMinimalModules = () => (
    <div className="modules-container">
      <h4>{getTemplateName(formData.template)}</h4>
      
      {/* Position de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="minimalPhotoPosition">Position de la photo</label>
        <select
          id="minimalPhotoPosition"
          className="form-input"
          value={formData.minimal?.photoPosition || 'gauche'}
          onChange={(e) => updateFormData('minimal', { ...formData.minimal, photoPosition: e.target.value })}
        >
          <option value="gauche">À gauche</option>
          <option value="droite">À droite</option>
          <option value="haut-milieu">Haut-milieu</option>
        </select>
      </div>

      {/* Forme de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="minimalPhotoFormat">Forme de la photo</label>
        <select
          id="minimalPhotoFormat"
          className="form-input"
          value={formData.minimal?.photoFormat || 'rond'}
          onChange={(e) => updateFormData('minimal', { ...formData.minimal, photoFormat: e.target.value })}
        >
          <option value="carre">Carré</option>
          <option value="carre-arrondi">Carré arrondi</option>
          <option value="rond">Rond</option>
        </select>
      </div>

      {/* Bordure autour de la photo */}
      <div className="form-group">
        <label className="form-label">Bordure autour de la photo</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.minimal?.photoBorder || false}
            onChange={(e) => updateFormData('minimal', { ...formData.minimal, photoBorder: e.target.checked })}
          />
          <span>Activer la bordure autour de la photo</span>
        </label>
      </div>

      {/* Position des réseaux sociaux */}
      <div className="form-group">
        <label className="form-label" htmlFor="minimalSocialPosition">Position des réseaux sociaux</label>
        <select
          id="minimalSocialPosition"
          className="form-input"
          value={formData.minimal?.socialPosition || 'horizontale-droite'}
          onChange={(e) => updateFormData('minimal', { ...formData.minimal, socialPosition: e.target.value })}
        >
          <option value="horizontale-droite">Horizontale à droite</option>
          <option value="horizontale-gauche">Horizontale à gauche</option>
          <option value="horizontale-centre">Horizontale centré</option>
          <option value="verticale-droite">Verticale à droite</option>
          <option value="verticale-gauche">Verticale à gauche</option>
        </select>
      </div>
    </div>
  );

  // Modules spécifiques au template Tech
  const renderTechModules = () => (
    <div className="modules-container">
      <h4>{getTemplateName(formData.template)}</h4>
      
      {/* Personnalisation du whoami */}
      <div className="form-group">
        <label className="form-label" htmlFor="techWhoami">Texte de la commande whoami</label>
        <input
          type="text"
          id="techWhoami"
          className="form-input"
          value={formData.tech?.whoami || 'whoami'}
          onChange={(e) => updateFormData('tech', { ...formData.tech, whoami: e.target.value.slice(0, 20) })}
          placeholder="whoami"
          maxLength="20"
        />
      </div>

      {/* Contour de la photo */}
      <div className="form-group">
        <label className="form-label">Contour de la photo</label>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={formData.tech?.photoContour !== false}
            onChange={(e) => updateFormData('tech', { ...formData.tech, photoContour: e.target.checked })}
          />
          <span>Activer le contour de couleur de la photo profil</span>
        </label>
      </div>

      {/* Forme de la photo */}
      <div className="form-group">
        <label className="form-label" htmlFor="techPhotoFormat">Forme de la photo profil</label>
        <select
          id="techPhotoFormat"
          className="form-input"
          value={formData.tech?.photoFormat || 'carre'}
          onChange={(e) => updateFormData('tech', { ...formData.tech, photoFormat: e.target.value })}
        >
          <option value="carre">Carré</option>
          <option value="carre-arrondi">Carré arrondi</option>
          <option value="rond">Rond</option>
        </select>
      </div>
    </div>
  );

  const renderModules = () => {
    switch (formData.template) {
      case 'moderne':
        return renderModerneModules();
      case 'moderne2':
        return renderModerne2Modules();
      case 'moderne3':
        return renderModerne3Modules();
      case 'carte':
        return renderCarteModules();
      case 'corporate':
        return renderCorporateModules();
      case 'creatif':
        return renderCreatifModules();
      case 'minimal':
        return renderMinimalModules();
      case 'tech':
        return renderTechModules();
      default:
        return (
          <div className="modules-container">
            <p>Aucun module disponible pour ce modèle.</p>
          </div>
        );
    }
  };

  return renderModules();
};

export default ModulesCustomization;